var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"disabled":_vm.disabled,"multiple":"","placeholder":"请选择国家","collapse-tags":""},on:{"change":_vm.handleChange},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.id,attrs:{"value":item.id,"label":item.name}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }